export default __webpack_public_path__ + "static/media/undercover-parking.inline.2c38cdea.svg";